import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
// import { toast } from "react-toastify";

import { handleBigNumbers } from "../utils";
import { Container } from "../layout/Container";
import FollowUnfollow from "../components/FollowUnfollow";
import Cards from "../components/Cards";
import { SmallAvatar } from "../components/Avatar";
import useTranslation from "../hooks/useTranslation";

import { ReactComponent as FilerIcon } from "../img/icons/filter.svg";
import { ReactComponent as VerifiedIcon } from "../img/icons/verified.svg";

import { LiveCards, VideoCards, TournamentCards, GameCards } from "../TmpData";

const Search = () => {
  const { t } = useTranslation();
  const channels = [
    {
      id: 1,
      url: "/username", // user URL Profile
      avatar:
        "https://static.displate.com/280x392/displate/2020-12-03/74d66b070ea47c4f0222cf9534f10244_4333de7ab4d91db29e7f5d91bb04a9c0.jpg",
      username: "username",
      isVerified: true,
      followers: 12312,
    },
  ];
  const videos = VideoCards;
  const lives = LiveCards;
  const tournaments = TournamentCards;
  const games = GameCards;

  return (
    <Container style={{ paddingTop: "4rem", paddingBottom: "2rem" }}>
      <h1>{t('search.search_results')}</h1>
      <header>
        <Filters />
      </header>
      <Results>
        {tournaments.length > 0 && <Tournaments data={tournaments} />}
        {channels.length > 0 && <Channels data={channels} />}
        {lives.length > 0 && <Lives data={lives} />}
        {videos.length > 0 && <Videos data={videos} />}
        {games.length > 0 && <Games data={games} />}
      </Results>
    </Container>
  );
};
export default Search;

const Channels = ({ data }) => {
  const { t } = useTranslation();
  return data.map((channel, index) => (
    <ChannelStyle key={index}>
      <div>
        <SmallAvatar to={channel.url} size="110px" src={channel.avatar} alt={channel.username} />
        <div>
          <Link to={channel.url}>
            <h4>
              {channel.username}
              {channel.isVerified && <VerifiedIcon />}
            </h4>
          </Link>
          <span>{handleBigNumbers(channel.followers)} {t('search.followers')}</span>
        </div>
      </div>
      <FollowUnfollow id={channel.id} />
    </ChannelStyle>
  ));
};
const Tournaments = ({ data }) => {
  const { t } = useTranslation();
  return (
    <>
      <h2>{t('search.tournaments')}</h2>
      {data.map((card, index) => (
        <Cards
          key={index}
          horizontal={true}
          state={card.state}
          to={card.to}
          thumbnailImg={card.thumbnailImg}
          avatarImg={card.avatarImg}
          userURL={card.userURL}
          title={card.title}
          verified={card.verified}
          username={card.username}
          tags={card.tags}
        />
      ))}
    </>
  );
};
const Lives = ({ data }) => {
  const { t } = useTranslation();
  //   console.log(data);

  return (
    <>
      <h2>{t('search.lives')}</h2>
      {data.map((card, index) => (
        <Cards
          key={index}
          horizontal={true}
          state={card.state}
          to={card.to}
          thumbnailImg={card.thumbnailImg}
          avatarImg={card.avatarImg}
          userURL={card.userURL}
          title={card.title}
          verified={card.verified}
          username={card.username}
          tags={card.tags}
        />
      ))}
    </>
  );
};
const Videos = ({ data }) => {
  const { t } = useTranslation();
  return (
    <>
      <h2>{t('search.videos')}</h2>
      {data.map((card, index) => (
        <Cards
          key={index}
          horizontal={true}
          state={card.state}
          to={card.to}
          thumbnailImg={card.thumbnailImg}
          avatarImg={card.avatarImg}
          userURL={card.userURL}
          title={card.title}
          verified={card.verified}
          username={card.username}
          tags={card.tags}
        />
      ))}
    </>
  );
};
const Games = ({ data }) => {
  const { t } = useTranslation();
  return (
    <>
      <h2>{t('search.games')}</h2>
      {data.map((card, index) => (
        <Cards
          key={index}
          horizontal={true}
          state={card.state}
          to={card.to}
          thumbnailImg={card.thumbnailImg}
          avatarImg={card.avatarImg}
          userURL={card.userURL}
          title={card.title}
          verified={card.verified}
          username={card.username}
          tags={card.tags}
        />
      ))}
    </>
  );
};
const Filters = () => {
  return (
    <Details>
      <summary>
        <FilerIcon />
        <h6>Filters</h6>
      </summary>
      <div>...</div>
    </Details>
  );
};

const Details = styled.details`
  border-bottom: 1px solid ${({ theme }) => theme.color.border};
  padding-bottom: 5px;
  margin-top: 24px;
  transition: height 3s ease-in;
  summary {
    position: relative;
    right: 18px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    padding: 10px 18px;
    border-radius: 4px;
    user-select: none;
    color: ${({ theme }) => theme.color.lighterText};
    transition: background-color 100ms;
    :hover {
      transition: background-color 200ms;
      background-color: ${({ theme }) => theme.color.secondaryBg};
    }
    h6 {
      letter-spacing: 0.6px;
      font-size: 14px;
      font-family: "Poppins Medium";
    }
    svg {
      margin-right: 10px;
      width: 14px;
      path {
        stroke: ${({ theme }) => theme.color.lighterText};
      }
    }
  }
  > div {
    margin: 10px 0;
  }
`;
const Results = styled.section`
  margin: 35px 0;
  h2 {
    margin-bottom: 24px;
  }
  > article {
    padding: 15px;
    transition: background-color 100ms;
    border-radius: 5px;
    :hover {
      background-color: ${({ theme }) => theme.color.secondaryBg};
      transition: background-color 200ms;
    }
  }
`;
const ChannelStyle = styled.article`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  @media (max-width: 400px) {
    flex-direction: column;
    align-items: center;
  }
  > div {
    flex: 1;
    min-width: 230px;
    display: flex;
    align-items: center;
    @media (max-width: 400px) {
      margin-bottom: 15px;
      flex-direction: column;
      align-items: center;
    }
    > a {
      margin-right: 18px;
      @media (max-width: 400px) {
        margin-right: 10px;
      }
      div {
        max-width: 80px;
        max-height: 80px;
        border: 3px solid ${({ theme }) => theme.color.background};
        transition: border-color 100ms;
      }
      :hover div {
        transition: border-color 200ms;
        border-color: ${({ theme }) => theme.color.primary};
      }
    }
    > div {
      @media (max-width: 400px) {
        text-align: center;
      }
      h4 {
        margin-bottom: 5px;
        color: ${({ theme }) => theme.color.darkerText};
        :hover {
          color: ${({ theme }) => theme.color.primary};
        }
        svg {
          margin-left: 7px;
        }
      }
      span {
        font-size: 14px;
        font-family: "Poppins Medium";
        color: ${({ theme }) => theme.color.lighterText};
      }
    }
  }
`;
